import type { Action } from 'state/actions';
import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { KycMap } from 'state/secondaryMarket/shared/kyc/kyc.model';
import { initialKycMap } from 'state/secondaryMarket/shared/kyc/kyc.model';
import { addOrReplaceKey, patchKey, removeKey } from 'state/utils/collection';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';

export function kycReducerFactory(actionType: OrderActionType, secondaryMarketTabType: SecondaryMarketQuotesTabType) {
  return (state: KycMap = initialKycMap(), action: Action): KycMap => {
    switch (action.type) {
      case `SECONDARY_MARKET_${actionType}_KYC_STATUS_REQUESTED` as const:
        return addOrReplaceKey(state, action.tabId, {
          isLoading: true,
          hasError: false,
          data: undefined,
        });
      case `SECONDARY_MARKET_${actionType}_KYC_STATUS_RECEIVED` as const:
        return patchKey(state, action.tabId, () => ({
          isLoading: false,
          hasError: false,
          data: action.data,
        }));
      case `SECONDARY_MARKET_${actionType}_KYC_STATUS_RESET` as const:
        return addOrReplaceKey(state, action.tabId, {
          isLoading: false,
          hasError: true,
          data: undefined,
        });
      case `SECONDARY_MARKET_${actionType}_KYC_STATUS_FAILED` as const:
        return patchKey(state, action.tabId, () => ({
          isLoading: false,
          hasError: true,
          data: undefined,
        }));
      case 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB':
      case 'SECONDARY_MARKET_QUOTES_WORKSPACE_REMOVE_TAB':
        if (action.tabType === secondaryMarketTabType) {
          return removeKey(state, action.tabId);
        }
        return state;
      default:
        return state;
    }
  };
}
